const ENSWOT = {
	"Sem importância":"Not important",
	"Menos importante":"Less important",
	"Mais importante":"More important",
	"Totalmente importante":"Totally important",
	"Muito fraca":"Very weak",
	"Fraca":"Weak",
	"Forte":"Strong",
	"Muito forte":"Very strong",
	"Sem urgência":"No urgency",
	"Menos urgente":"Less urgent",
	"Muito urgente":"More urgent",
	"Totalmente urgente":"Totally urgent",
	"Piora muito":"Get worse a lot",
	"Piora":"Get worse",
	"Mantém":"Maintain",
	"Melhora":"Improve",
	"Melhora muito":"Improves a lot",
	"Erro ao buscar análises SWOT":"Error on search SWOT analysis",
	"Nova análise SWOT":"New SWOT analysis",
	"Análise SWOT adicionada com sucesso": "SWOT analysis successfully added",
	"Análise SWOT alterada com sucesso": "SWOT analysis successfully changed",
	"Análise SWOT excluída com sucesso": "SWOT analysis successfully deleted",
	"Erro ao adicionar análise SWOT": "Error adding SWOT analysis",
	"Erro ao alterar análise SWOT": "Error changing SWOT analysis",
	"Erro ao excluir análise SWOT": "Error deleting SWOT analysis",
	"Adicionar análise SWOT":"Add SWOT analysis",
	"Copiar análise SWOT":"Copy SWOT analysis",
	"Erro ao buscar análise SWOT":"Error on search SWOT analysis",
	"Exclusão da análise SWOT":"Delete SWOT analysis",
	"Digite o nome da análise para excluí-lo":"Enter the name of the SWOT analysis to delete it",
	"Deseja realmente excluir a análise":"Do you really want to delete the analysis",
	"Dimensão padrão":"Default dimension",
	"Titulo da análise não confere":"Analysis title does not match",
	"Título deve conter no máximo 60 caracteres": "Title must contain a maximum of 60 characters",
	"A dimensão é obrigatória":"Dimension is required",
	"Aspectos internos que contribuem para a estratégia da sua empresa":"Internal aspects that contribute to your company's strategy",
	"Aspectos internos que dificultam a estratégia da sua empresa":"Internal aspects that hinder your company's strategy",
	"Aspectos externos que contribuem para a estratégia da sua empresa":"External aspects that contribute to your company's strategy",
	"Aspectos externos que dificultam a estratégia da sua empresa":"External aspects that hinder your company's strategy",
	"Associar mapa":"Associate map",
	"Vincular itens da SWOT":"Linking SWOT items",
	"Alterar dimensão":"Change dimension",
	"Item adicionado com sucesso": "Item successfully added",
	"Item alterado com sucesso": "Item successfully changed",
	"Item excluído com sucesso": "Item successfully deleted",
	"Erro ao adicionar item": "Error adding item",
	"Erro ao alterar item": "Error changing item",
	"Erro ao atualizar item": "Error update item",
	"Erro ao excluir item": "Error deleting item",
	"Deseja realmente excluir o item":"Do you really want to delete the item",
	"Aqui é preciso entender o quanto o item tem de impacto na estratégia da empresa":"Here you need to understand how much impact the item has on the company's strategy",
	"Adicionar item":"Add item",
	"o valor mais baixo, até":"the lowest value, to",
	"apartir de":"from",
	"o valor mais alto":"the highest value",
	"O quanto o item pode escalar ou diminuir de impacto na sua estratégia":"How much the item can scale up or down in impact on your strategy",
	"com o valor mais baixo representando que ele não tem como impactar mais e o valor mais alto representando que ele ainda pode impactar muito":"with the lowest value representing that he has no way to impact more and the highest value representing that he can still impact a lot",
	"Aqui será avaliado o quanto o item tem a tendência de se manter ou deixar de existir":"Here you will evaluate how much the item tends to remain or cease to exist",
	"A tendência de se manter é o valor mais alto e a tendência de deixar de existir é o valor mais baixo":"The tendency to remain is the highest value and the tendency to cease to exist is the lowest value",
	"A pontuação é dada pela multiplicação dos pontos da importância":"The score is given by multiplying the points of importance",
	"Ajuda a realização dos objetivos":"Helps the achievement of goals",
	"Atrapalha a realização dos objetivos":"Hinders the achievement of goals",
	"Origem interna":"Internal origin",
	"Origem externa":"External origin",
	"Quais os pontos fortes de seu negócio":"What are the strengths of your business",
	"Quais os pontos fracos de seu negócio":"What are the weaknesses of your business",
	"Quais as oportunidades para seu negócio":"What are the opportunities for your business",
	"Quais as ameaças para seu negócio":"What are the threats to your business",
	"Nenhuma análise SWOT selecionada":"No SWOT analysis selected",
	"Selecione uma análise para ver seus detalhes":"Select an analysis to see its details",
	"Erro ao buscar estratégias SWOT":"Error on search SWOT strategies",
	"Não há itens vinculados para essa estratégia SWOT":"There are no linked items for this SWOT strategy",
	"Erro ao excluir vinculo":"Error on delete link",
	"Erro ao buscar itens SWOT":"Error on search SWOT itens",
	"Erro ao buscar item SWOT":"Error on search SWOT item",
	"Detalhes do item":"Item's details",
	"Criar ligação":"Create link",
	"Excluir ligação":"Delete link",
	"Erro ao vincular item com objetivos":"Error on link item with objectives",
	"Selecione os objetivos para associar":"Select objectives to link",
	"Erro ao buscar vinculos com objetivos":"Error on search objectives links",
	"Selecione uma dimensão":"Select a dimension",
	"Nova dimensão":"New dimension",
	"Erro ao vincular itens SWOT":"Error on link SWOT itens",
	"Erro ao buscar vinculos com itens SWOT":"Error on search SWOT itens Links",
	"Nenhum vinculo de item encontrado":"No links were found for this item",
	"Nenhum item encontrado":"No itens found",
	"Nenhuma rastreabilidade encontrada": "No traceability found",
	"Consolidado":"Consolidated",
	"Dimensões Padrões":"Default Dimensions",
	"Dimensões da Empresa":"Business Dimensions",
	"Exclusão do item de SWOT":"Delete Swot Item",
	"Vinculos alterados com sucesso":"Links successfully changed",
	"Exclusão de vinculo":"Delete link",
	"Deseja realmente excluir o vinculo dos itens":"Do you really want to delete the itens link",
	// tradução das estrategias padrao do banco
	"Estratégias SO (Strengths x Opportunities)":"SO Strategies (Strengths x Opportunities)",
	"Estratégias ST (Strengths x Threats)":"ST Strategies (Strengths x Threats)",
	"Estratégias WO (Weaknesses x Opportunities)":"WO Strategies (Weaknesses x Opportunities)",
	"Estratégias WT (Weaknesses x Threats)":"WT Strategies (Weaknesses x Threats)",
	"Ofensiva":"Offensive",
	"Confrontativa":"Confrontation",
	"Reforço":"Reinforcement",
	"Defensiva":"Defensive",
	"Capitalizar":"Capitalize",
	"Melhorar":"Improve",
	"Monitorar":"Watch",
	"Eliminar":"Delete",
	"Consiste na junção das forças internas com as oportunidades externas. Seu objetivo é aumentar e aperfeiçoar as forças para que as oportunidades sejam bem aproveitadas, se tornando vantagens competitivas."
	:"It consists of the combination of internal strengths with external opportunities. The objective is to increase and improve the strengths so that the opportunities are well used, becoming competitive advantages.",
	"Consiste na junção das forças internas com ameaças externas. Nela, são desenvolvidas estratégias de confronto que utilizam os pontos fortes da empresa para diminuir as ameaças."
	:"It consists of the combination of internal strengths with external threats. Here, confrontation strategies are developed that use the company's strengths to reduce the threats.",
	"Consiste na junção das fraquezas internas e oportunidades externas. Seu objetivo é analisar as fraquezas de forma a tentar superá-las para aproveitar as oportunidades."
	:"It consists of the combination of internal weaknesses and external opportunities. The objective is to analyze the weaknesses in order to try to overcome them to take advantage of the opportunities.",
	"Consiste na junção das fraquezas internas e ameaças externas. Nela, são desenvolvidas ações defensivas para proteger a empresa, diminuindo o impacto das ameaças."
	:"It consists of the combination of internal weaknesses and external threats. Here, defensive actions are developed to protect the company, reducing the impact of threats.",
	"Sem Objetivo":"Without Objective"
};

export default ENSWOT;
